import { useContext, useMemo } from "react";
// constants
import { TIMESACT_VERSION_2 } from "../../common/constants";
// contexts
import { VersionStoreContext } from "../../contexts/VersionStoreContext";
import NavigationMenuV1 from "./NavigationMenuV1";
import NavigationMenuV2 from "./NavigationMenuV2";

const NavigationMenu = () => {
  const { timesactVersion, isVersionLoaded } = useContext(VersionStoreContext);
  const memoizedV1 = useMemo(() => <NavigationMenuV1 />, []);
  const memoizedV2 = useMemo(() => <NavigationMenuV2 />, []);

  if (!isVersionLoaded) {
    return;
  }

  if (timesactVersion && timesactVersion === TIMESACT_VERSION_2) {
    return memoizedV2;
  } else {
    return memoizedV1;
  }
};

export default NavigationMenu;
